<template>
  <div class="preview-box">
    <div class="p-header">
      <div class="form-inline">
        <div class="form-group">
          <label>{{multiLanguage.preview.subordinateType}}：</label>
          <div class="input-group">
            <select class="form-control" style="border-radius: 3px;" v-model="type">
              <option value="0">{{multiLanguage.preview.all}}</option>
              <option value="1">{{multiLanguage.preview.directCustomer}}</option>
              <option value="2">{{multiLanguage.preview.directIB}}</option>
              <option value="3">{{multiLanguage.preview.other}}</option>
            </select>
          </div>
        </div>
        <div class="form-group input-group">
            <input type="text" class="form-control" v-model="seachVal" @keyup.enter="seachFn">
            <div class="input-group-addon btn btn-primary" @click="seachFn" >
              {{multiLanguage.preview.search}}
            </div>
        </div>
        <div class="form-group pull-right">
          <label>{{multiLanguage.preview.showClauses}}：</label>
          <div class="input-group">
            <select class="form-control" style="border-radius: 3px;" v-model="clause">
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
          </div>
        </div>
        
        <div class="form-group">
          <jsonExcel class="btn btn-default" style="margin-left: 20px;padding: 8px 12px;" name="filename.xlsx"
            :ajaxUrl="jsonExcelAjax.url || false" :ajaxPar="jsonExcelAjax.ajaxPar || false" 
            :ajaxType="jsonExcelAjax.ajaxType" :keys="thData" :ajaxGetKey="jsonExcelAjax.getKey" 
            :multiLanguage="publicLan"
            :publicLan="publicLan"
            :colData="[]" :mainAcc="mainAcc"
            :reqData="reqData">
            <i class="glyphicon glyphicon-save tab-he-glyphicon"></i>
            {{multiLanguage.downloadExcel}}
          </jsonExcel>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <div class="p-body" v-loading="loading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.5)">
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th v-for="item in multiLanguage.previewThead">{{item.text}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in previewData">
            <td>{{mainAcc}}</td>
            <td>{{publicLan.type[item.type]}}</td>
            <td>{{item.account}}</td>
            <td>{{item.name}}</td>
            <td>{{publicLan.relationType[item.relationType]}}</td>
            <td>
              <span v-for="(data,index) in item.condition">
                <span v-for="(d,i) in reqData" v-if="d.ruleId === data.ruleId">
                  {{data.clientType == 1 ? publicLan.clientType.IBClient : data.clientType == 2 ? publicLan.clientType.directClient : ''}}
                  {{publicLan.rule[d.langKey.split('.')[1]]}} : {{data.value}}；
                </span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="p-footer" style="line-height:36px;height:36px;overflow:hidden;">
      <div class="pull-left">
        {{multiLanguage.preview.totalClauses}}：{{totalData}}
        {{multiLanguage.preview.current}}：{{(currentPage-1)*clause+1}} - {{Math.min(currentPage*clause,totalData)}}
      </div>
      <pagination v-model="currentPage" boundary-links :total-page="totalPage" align="right" @change="callpageFn" class="pull-right"></pagination>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
  import { Pagination } from 'uiv'
  import jsonExcel from "components/commissionJsonExcel"
  import { Api } from 'api/commissionEnv'
  import { URL_SALESPREVIEW } from 'api/commissionApi'
  var api = new Api()

  export default {
    mixins: [ require("common/mixin/base.js").base({publicLan:"publicLan"}) ],
    props: {
      region: {
        type: String,
        default: '',
      },
      multiLanguage: {
        type: Object,
        default: {},
      },
      reqData: {
        type: Array,
        default: []
      }
    },
    components: {
      Pagination,
      jsonExcel,
    }, 
    computed: {
      thData () {
        let arr = []
        this.multiLanguage.previewThead.forEach(element => {
          arr.push(element.text)
        })
        return arr 
      },
      jsonExcelAjax () {
        return {
          url: api.getUrl20(this.region,URL_SALESPREVIEW)+'/'+this.mainAcc,
          ajaxType: "get",
          getKey: ["data", "data","data"],
          ajaxPar: {
            pageNum: 0,
            pageSize: this.totalData,
            type: this.type,
            seekVal: this.seachVal,
          }
        }
      },
    },
    mounted () {
      this.pageInit()
    },
    data () {
      return {
        loading: false,
        clause: '5',
        type: '0',
        seachVal: '',
        currentPage: 1,
        totalPage: 0,
        totalData: 0,
        previewData: [],
        mainAcc: this.$route.query.id,
      }
    },
    methods: {
      pageInit (){ // 初始化数据
        this.loading = true
        this.$http.get(api.getUrl20(this.region,URL_SALESPREVIEW)+'/'+this.mainAcc,{params: {
          pageNum: this.currentPage-1,
          pageSize: this.clause,
          type: this.type,
          seekVal: this.seachVal,
        }}).then(res => {
          if(res.data.code == 200 && res.data.data && res.data.msg == 'OK') {
            this.previewData = res.data.data.data
            this.totalData = res.data.data.count
            this.totalPage = Math.ceil(res.data.data.count / this.clause)
            this.loading = false
          }
        })
      },
      callpageFn () { // 翻页的方法
        this.pageInit()
      },
      seachFn () { // 搜索的方法
        this.currentPage = 1
        this.pageInit()
      }
    },
    watch: {
      clause (curVal) { // 监听条目的变化
        this.currentPage = 1
        this.pageInit()
      },
      region () {
        this.pageInit()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .preview-box{
    .p-body{
      margin-top: 20px;
      table{
        thead{
          background-color: #EBEDF7;
        }
      }
    }
    .p-footer{
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// saleCommissionPreview.vue?0f65c992